$(document).ready(function (){

    $("#submitFormBtn").click(function (e) {
        e.preventDefault()
        const name = $("#name").val();
        const email = $("#email").val();
        const phone = $("#phone").val();
        const message = $("#message").val();
        $.ajax({
            url: "/send-mail",
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {
                name: name,
                email: email,
                phone: phone,
                message: message
            },
            beforeSend: function () {
                $('form').css('opacity', '0');
                $("#loader").show();
            },
            success: function (response) {
                $("#loader").hide();
                if (response['code'] == 200){
                    toastr.success(response['message']);
                    $(':input')
                        .not(':button, :submit, :reset, :hidden')
                        .val('')
                    $('form').hide()
                    $(".success-message").fadeIn()
                }
                else {
                    toastr.warning(response['message']);
                }

            },

            error: function (response){
                $("#loader").hide();
                $('form').css('opacity', '1');
                let resp = JSON.parse(response.responseText);
                if (resp['errors']){
                    let errors = resp['errors']
                    for (const [x,  y] of Object.entries(resp['errors'])){
                        toastr.error(y[0])
                    }
                }
            }


        });
    })

})
